export const RECEIVE_USER = "user/RECEIVE_USER"

const initialState = {};

export default function user(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_USER:
      return {...state, ...action.user}
    default:
      return state;
  }
}